// extracted by mini-css-extract-plugin
module.exports = {"passenger":"passenger-Dg-uu","active":"active-mYXtM","label":"label-28Cmo","checkbox":"checkbox-2VXwC"};